import { createSlice } from '@reduxjs/toolkit'

export const inputSlice = createSlice({
  name: 'input',
  initialState: {
    searchValue: '',
  },
  reducers: {
    setSearchValue: (state, { payload }) => {
      state.searchValue = payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setSearchValue } = inputSlice.actions

export const inputSelector = (state) => state.input
export const inputReducer = inputSlice.reducer
